export default __webpack_public_path__ + "static/media/BillGates.38f95135.jpeg";